<template>
  <div id="notfound_wrap">
    <div id="notfound">
      <div>
        <div>
          <Icon
            style="font-size: 24px; margin-right: 8px"
            type="md-radio-button-on"
          />
          <span>非常抱歉</span>
        </div>

        <h2>404!</h2>
        <p>
          当前页面找不到了，请联系技术人员或者先回到主页使用其他相关功能服务
        </p>
        <div style="width: 150px">
          <Button size='large' type="success" long @click="goto">回到首页</Button>
        </div>
      </div>
      <img src="static/404.png" />
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goto() {
      this.$router.push({
        path: "/home",
        query: { now: 0 },
      });
    },
  },
};
</script>
<style>
#notfound_wrap {
  width: 100%;
  height: 100%;
  background: #31384a;
  padding-top: 100px;
  color: #fff;
}
#notfound {
  margin: auto;
  width: 1000px;
  display: flex;
}
#notfound img {
  margin-left: auto;
}
#notfound h2 {
  margin-top: 60px;
  margin-bottom: 10px;
  font-size: 100px;
  font-weight: bold;
}
#notfound p {
  margin-bottom: 100px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue